module.exports = require("./ru-UA.d.ts");